export default __webpack_public_path__ + "assets/PlayIcon.svg";